<template>
  <div class="import-summary">
    <template
      v-if="
        importData &&
          importData.status &&
          importData.status === LOCATION_IMPORT_STATUS.PENDING
      "
    >
      <div class="import-summary__in-progress">
        <v-icon color="primary" class="mr-2">icon-status-pending</v-icon>
        {{
          $t("message.companyProfile.listings.importSummary.importInProgress")
        }}
      </div>
      <div class="d-flex">
        <div
          v-if="summaryData && summaryData.imported > 0"
          class="import-summary__imported-status"
        >
          {{
            $t(
              "message.companyProfile.listings.importSummary.importedStatistics",
              {
                current_count: summaryData.success,
                total_count: summaryData.imported
              }
            )
          }}
        </div>
        <div>
          {{
            $t("message.companyProfile.listings.importSummary.lastCheckedAt", {
              time: updateTime
            })
          }}
        </div>
      </div>
      <SectionLoader :status="refreshPending" :opacity="0.75" />
    </template>

    <template
      v-if="
        importData &&
          importData.status &&
          (importData.status === LOCATION_IMPORT_STATUS.COMPLETED ||
            importData.status === LOCATION_IMPORT_STATUS.FINISHED_WITH_PROBLEMS)
      "
    >
      <div class="import-summary__info">
        <p class="mb-0 lh-24">
          {{ $t("message.companyProfile.listings.importSummary.lastImport") }}
        </p>
        <span class="import-summary__date lh-24">
          {{ importDate }}
        </span>
      </div>
      <div
        class="import-summary__info"
        v-if="importData && importData.statistics"
      >
        <p class="mb-0 lh-24">
          {{
            $t(
              "message.companyProfile.listings.importSummary.importedLocations"
            )
          }}
        </p>
        <span class="import-summary__date lh-24">
          {{ importData.statistics.imported_locations_count }}
        </span>
        <button
          class="import-summary__details"
          @click="confirmationDialog = true"
        >
          {{ $t("message.common.details") }}
        </button>
        <v-icon
          v-if="
            importData.status === LOCATION_IMPORT_STATUS.FINISHED_WITH_PROBLEMS
          "
          color="lime"
          class="ml-2"
          size="17.5"
        >
          icon-info
        </v-icon>
      </div>
    </template>

    <ImportSummaryDialog
      :is-open="confirmationDialog"
      :summary-data="summaryData"
      @close="confirmationDialog = false"
    />
  </div>
</template>

<script>
import moment from "moment";
import { FORMAT } from "@/config/date-format";

import { LOCATION_IMPORT_STATUS } from "@/enums/gmb-locations-import";

import ImportSummaryDialog from "@/components/ListingsConfiguration/Dialog/ImportSummaryDialog.vue";
import SectionLoader from "@/components/Loader/SectionLoader.vue";

export default {
  name: "LocationsImportSummary",
  components: { ImportSummaryDialog, SectionLoader },
  data() {
    return {
      confirmationDialog: false,
      LOCATION_IMPORT_STATUS,
      updateTime: moment().format(FORMAT.DATE_HMS)
    };
  },
  props: {
    importData: {
      type: Object,
      default: () => {}
    },
    refreshPending: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    importData(newVal) {
      if (newVal) {
        this.updateTime = moment().format(FORMAT.DATE_HMS);
      }
    }
  },
  computed: {
    importDate() {
      return this.importData
        ? moment(this.importData.updated_at).format(FORMAT.DATE)
        : null;
    },
    notImportedLocationsCount() {
      return this.importData && this.importData.statistics
        ? this.importData.statistics.disabled_locations_count +
            this.importData.statistics.duplicated_locations_count +
            this.importData.statistics.locations_without_address_lines_count +
            this.importData.statistics.locations_without_placeid_count +
            this.importData.statistics.other_problem_count
        : 0;
    },
    alreadyImportedLocationsCount() {
      return this.importData && this.importData.statistics
        ? this.importData.statistics.imported_from_other_profile_count
        : 0;
    },
    summaryData() {
      return {
        imported:
          this.importData && this.importData.locations_count
            ? this.importData.locations_count
            : 0,
        success:
          this.importData && this.importData.statistics
            ? this.importData.statistics.imported_locations_count
            : 0,
        error: this.notImportedLocationsCount,
        alreadyImported: this.alreadyImportedLocationsCount,
        unverified:
          this.importData && this.importData.statistics
            ? this.importData.statistics.unverified
            : 0
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.import-summary {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-top: $spacing * 1.5;
  @include font-size(12px);
  font-weight: 400;
  color: $text;
  padding: $spacing * 1.5 $spacing * 5;
  background-color: $light-4;
  border-radius: 8px;

  &__imported-status {
    padding-right: $spacing * 2;
    margin-right: $spacing * 2;
    border-right: 1px solid rgba($text, 0.7);
  }

  &__info {
    display: flex;
  }

  &__in-progress,
  &__date,
  &__imported-count {
    @include font-size(14px);
    font-weight: 600;
    color: $primary;
  }
  &__date,
  &__imported-count {
    margin-left: $spacing;
  }

  &__details {
    margin-left: $spacing * 2;
    font-weight: 600;
    text-decoration: underline;
  }
}

.lh-24 {
  line-height: 24px;
}
</style>
